export const UPDATE_PAGES_SUCCESS = 'UPDATE_PAGES_SUCCESS'
export const UPDATE_PAGES_FAILED = 'UPDATE_PAGES_FAILED'
export const UPDATE_PAGES_START = 'UPDATE_PAGES_START'

export const updatePagesSuccess = data => ({
	type: UPDATE_PAGES_SUCCESS,
	data,
})

export const updatePagesFailed = () => ({
	type: UPDATE_PAGES_FAILED,
})

export const updatePagesStart = () => ({
	type: UPDATE_PAGES_START,
})

export const updatePages = () => (dispatch, getState, {fetchPages}) => {
	dispatch(updatePagesStart())
	return fetchPages()
		.then(data => dispatch(updatePagesSuccess(data)))
		.catch(() => dispatch(updatePagesFailed()))
}



// WEBPACK FOOTER //
// ./src/actions/pages.js